export default __webpack_public_path__ + "static/media/thum2.1ea5e78c.jpg";